import ApiProducts from "api/ApiProducts"
import { memo, useCallback } from "react"
import styled from "styled-components"
import SelectV2, { Option } from "./select/SelectV2"
import IconError from "components/icons/IconError"
import { Colors } from "themes/palette"
import clsx from "clsx"

const Container = styled.div`
  width: 100%;
`

const SelectDisabled = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.palette.white};
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.palette.disabled};
  display: flex;
  font-size: 16px;
  height: 49px;
  justify-content: flex-start;
  line-height: 19px;
  padding: 9px 14px;
  width: 100%;
  color: ${(props) => props.theme.palette.disabled};
`

const SelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
`

const ContainerIcon = styled.div`
  display: flex;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
  }
`

interface ProductPros {
  onChange: (product: string) => void
  isDisabled?: boolean
  disabledValue?: string
  value: string
  label: string
  cleanFilter?: boolean
  className?: string
}

const ProductSelector = (props: ProductPros) => {
  const { onChange, disabledValue, isDisabled, value, label, cleanFilter, className } = props

  const handleSelectChange = useCallback(
    (option: Option | null) => {
      onChange(option ? option.value : "")
    },
    [onChange]
  )

  const getData = useCallback(async () => {
    const { products } = await new ApiProducts().getAll()

    const results = products.map((product) => ({
      value: product.prefixUrl,
      label: product.prefixUrl
    }))

    return {
      hasMore: false,
      results
    }
  }, [])

  const handleClearFilters = useCallback(() => {
    onChange("")
  }, [onChange])

  return (
    <Container>
      {!isDisabled && (
        <SelectContainer>
          <SelectV2
            id="product"
            value={value}
            onChange={handleSelectChange}
            label={label || ""}
            getData={getData}
            className={className}
          />
          {cleanFilter && (
            <ContainerIcon onClick={handleClearFilters} className={clsx({ disabled: !value })}>
              <IconError color={value ? Colors.primary_dark : Colors.disabled} />
            </ContainerIcon>
          )}
        </SelectContainer>
      )}

      {isDisabled && <SelectDisabled>{disabledValue}</SelectDisabled>}
    </Container>
  )
}

export default memo(ProductSelector)
